import { Injectable, signal } from '@angular/core';

@Injectable()
export class QuickBetRendererService {
    private summaryCalculated = signal<boolean>(false);

    set summaryCalculationFinished(calculated: boolean) {
        this.summaryCalculated.set(calculated);
    }

    get summaryLoaded() {
        return this.summaryCalculated();
    }
}
